import AppRoutes from "@routes/Routes";
import AppProviders from "@src/AppProviders";

const App: React.FC = () => (
  <AppProviders>
    <AppRoutes />
  </AppProviders>
);

export default App;
